<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      item-key="id"
      class="elevation-1 mt-3"
      hide-default-footer
      disable-pagination
      v-bind="$attrs"
      v-model="selected"
      checkbox-color="primary"
      :single-select="true"
      @input="itemSelected"
    >
      <template v-slot:[`item.categoryType`]="{ item }">
        <span>
          {{ translate(item.categoryType) }}
        </span>
      </template>
      <template v-slot:[`item.disabled`]="{ item }">
        <span>
          {{ item.disabled ? 'غیر فعال' : 'فعال' }}
        </span>
      </template>
      <template v-slot:[`item.isDisabled`]="{ item }">
        <span>
          {{ item.isDisabled ? 'غیر فعال' : 'فعال' }}
        </span>
      </template>

      <template v-slot:[`item.oppositeSideType`]="{ item }">
        <p
          v-html="$t('voucher.oppositeSideTypes.' + item.oppositeSideType)"
        ></p>
      </template>
      <template v-slot:[`item.hasConstantList`]="{ item }">
        <span>
          {{ item.hasConstantList ? 'دارد' : 'ندارد' }}
        </span>
      </template>
      <template v-slot:[`item.propertyType`]="{ item }">
        <span>
          {{ translate(item.propertyType) }}
        </span>
      </template>
      <template v-slot:[`item.controlFactorProperty`]="{ item }">
        <span>
          {{ item.inventoryControlFactorProperty.title }}
        </span>
      </template>
      <template v-slot:[`item.nature`]="{ item }">
        <span>
          {{ translate(item.nature) }}
        </span>
      </template>
      <template v-slot:[`item.processType`]="{ item }">
        <span>
          {{ translate(item.processType) }}
        </span>
      </template>
      <template v-slot:[`item.type`]="{ item }">
        <span>
          {{ translate(item.type) }}
        </span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span>
          {{ translate(item.status) }}
        </span>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <span>
          {{ new Date(item.date).toLocaleDateString('fa-IR') }}
        </span>
      </template>
      <template v-slot:[`item.foundationType`]="{ item }">
        <span>
          {{ translate(item.foundationType) }}
        </span>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <span> {{ item.firstName }} {{ item.lastName }} </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          small
          outlined
          color="primary"
          @click="enableItem(item)"
          v-if="item.disabled && showStatus"
        >
          <v-icon>mdi-check</v-icon>
          فعال کردن
        </v-btn>
        <v-btn
          small
          outlined
          @click="disableItem(item)"
          v-else-if="!item.disabled && showStatus"
        >
          <v-icon>mdi-close</v-icon>
          غیر فعال کردن
        </v-btn>
        <v-btn small outlined @click="showDetail(item)" v-if="showDetailItem">
          نمایش جزئیات
        </v-btn>
        <v-btn icon color="primary" @click="editItem(item)" v-if="editable">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="deleteItem(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <template v-for="(_, slotName) of $scopedSlots" v-slot:[slotName]="scope">
        <slot :name="slotName" v-bind="scope" />
      </template>
      <template v-slot:no-data>
        <p>جدول خالی است</p>
      </template>
    </v-data-table>
    <div class="text-center pt-2" v-if="pagination">
      <v-row>
        <v-col cols="12" sm="2" md="2">
          <v-select
            outlined
            dense
            v-model="itemsPerPage"
            :items="[5, 10, 20]"
            label="تعداد نمایش در صفحه"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="10" md="10">
          <v-pagination
            circle
            v-model="pageNumber"
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: [],
    },
    items: {
      type: Array,
      default: [],
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    deleteable: {
      type: Boolean,
      default: true,
    },
    showDetailItem: {
      type: Boolean,
      default: false,
    },
    selections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pageNumber: 1,
      itemsPerPage: 10,
      selected: [],
    };
  },
  computed: {
    pageCount() {
      switch (this.type) {
        case 'holdingCenter':
          return ;
        default:
          return;
      }
    },
  },
  watch: {
    itemsPerPage() {
      this.$emit('itemsPerPageChanged', this.itemsPerPage);
    },
    pageNumber() {
      this.$emit('pageNumberChanged', this.pageNumber);
    },
  },
  methods: {
    itemSelected(rows) {
      this.$emit('items-selected', rows);
    },
    editItem(item) {
      this.$emit('editItem', item);
    },
    deleteItem(item) {
      this.$emit('deleteItem', item);
    },
    enableItem(item) {
      this.$emit('enableItem', item);
    },
    disableItem(item) {
      this.$emit('disableItem', item);
    },
    showDetail(item) {
      this.$emit('showDetail', item);
    },
    translate(en) {
      const Fa = {
        Number: 'عدد',
        Reference: 'حرفی',
        Date: 'تاریخ',
        Text: 'متن',
        Logical: 'منطقی',
        exitPermit: 'مجوز خروج',
        ReserveInWarehouse: 'رزرو در انبار',
        RequestFromWarehouse: 'درخواست از انبار',
        TemporaryDocument: 'سند موقت',
        Amani: 'امانی',
        Other: 'دیگر',
        Weight: 'وزن',
        Area: 'ناحیه',
        Volume: 'صدا',
        Time: 'زمان',
        Energy: 'انرژی',
        Temperature: 'دما',
        Pressure: 'فشار',
        Frequency: 'فرکانس',
        OtherCounting: 'سایر واحد های شمارش',
        PrimarySubstance: 'ماده اولیه',
        FinalItem: 'محصول نهایی',
        SemiMade: 'نیمه ساخته',
        FixedAssets: 'درست شده',
        Buy: 'خرید',
        Sale: 'فروش',
        Production: 'تولید',
        Consumption: 'مصرف',
        Wastage: 'ضایعات',
        TransferBetweenWarehouse: 'انتقال',
        WarehouseHandling: 'انبار گردانی',
        Adjustment: 'تعدیل',
        Item: 'کالا',
        NotReceived: 'دریافت نشده',
        Received: 'دریافت شده',
        Receiving: 'درحال دریافت',
        NoFoundation: 'بدون مبنا',
        entryPermit: 'مجوز ورود',
        Buy: 'خرید',
        Production: 'تولید',
        Consumption: 'مصرف',
      };
      return Fa[en];
    },
  },
};
</script>

<style lang="scss" scoped></style>
